<template>
  <main v-if="projects && projects.length > 0">
    <index v-if="$route.name == 'home'" />
    <list v-if="$route.name == 'list'" />
    <info v-if="$route.name == 'info'" />
    <projects-view v-if="$route.name !== 'info' && $route.name !== 'list' && $route.name !== 'home'" />
  </main>
  <main v-else class="loading">
    LOADING
  </main>
</template>

<script>
const Index = () => import(/* webpackChunkName: "Index" */ "@/views/Index.vue");
const ProjectsView = () =>
  import(/* webpackChunkName: "ProjectsView" */ "@/views/ProjectsView.vue");
const Info = () => import(/* webpackChunkName: "Info" */ "@/views/Info.vue");
const List = () => import(/* webpackChunkName: "List" */ "@/views/List.vue");
import { mapState } from "vuex";
export default {
  name: "home",
  components: {
    Index,
    ProjectsView,
    Info,
    List
  },
  metaInfo() {
    return {
      title: this.site.title,
      titleTemplate: null
    };
  },
  computed: mapState(["site", "projects"])
};
</script>

<style lang="scss" scoped>
main {
  width: 100%;
  height: 100%;
  &.loading {
    padding: 0.25rem;
  }
}
</style>
